import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SpeedInsights } from "@vercel/speed-insights/react"

// More comprehensive ResizeObserver error suppression
const originalError = console.error;
const originalWarn = console.warn;

// Helper function to check if an error is ResizeObserver related
const isResizeObserverError = (message: any): boolean => {
  if (typeof message !== 'string') return false;
  return message.toLowerCase().includes('resizeobserver') && 
         (message.includes('loop') || message.includes('undelivered'));
};

console.error = (...args) => {
  if (isResizeObserverError(args[0])) {
    return;
  }
  originalError.apply(console, args);
};

console.warn = (...args) => {
  if (isResizeObserverError(args[0])) {
    return;
  }
  originalWarn.apply(console, args);
};

// Global error suppression for ResizeObserver - multiple event types
const handleResizeObserverError = (e: ErrorEvent) => {
  if (isResizeObserverError(e.message) || isResizeObserverError(e.error?.message)) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  }
};

window.addEventListener('error', handleResizeObserverError, true);
window.addEventListener('error', handleResizeObserverError, false);

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  if (isResizeObserverError(String(e.reason))) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

// Override the global error handler used by React
const originalOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (isResizeObserverError(String(message))) {
    return true; // Prevent default handling
  }
  return originalOnError ? originalOnError(message, source, lineno, colno, error) : false;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
    <SpeedInsights />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
